import React from "react";
import { ddiDoctors, ddiLogo, wsmallFlower } from "../../assets";
import { Link } from "react-router-dom";
import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiLogoYoutube,
} from "react-icons/bi";
import { motion } from "framer-motion";

const DhakaDermatology = () => {
  return (
    <div id="ddi-isntitute">
      {/* <VideoCard v_src="https://www.youtube.com/embed/VC7pbm6x6_E?si=4wfh3TltcO3_1zvI" /> */}

      <motion.div
        className="content"
        whileInView={{ opacity: [0, 1], y: [20, 0] }}
        transition={{ duration: 0.7 }}
      >
        <img src={ddiDoctors} alt="" className="banner" />

        <div className="context">
          <img src={ddiLogo} alt="" className="ddiLogo" />

          <h1>Dhaka Dermatology Institute.</h1>
          <p>
            Bangladesh's highest medical center with international reputation.
          </p>

          <div className="highLight">
            <img src={wsmallFlower} alt="" />
            <span>Stepped in 5 years</span>
          </div>

          <div className="v-line"></div>

          <div className="social-links">
            <Link to="https://www.youtube.com/@DhakaDermatologyInstitute">
              <BiLogoFacebook className="socialIO" />
            </Link>
            <Link to="https://www.instagram.com/dhakadermatologyinstitute/">
              <BiLogoInstagramAlt className="socialIO" />
            </Link>
            <Link to="https://www.facebook.com/DhakaDermatologyInstitute/">
              <BiLogoYoutube className="socialIO" />
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default DhakaDermatology;
